// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3Iuh7","dragIcon":"Choice_dragIcon__9XLxA","left":"Choice_left__XKzdn","input":"Choice_input__2dB2Z"};